import { Col, Container, Image, Row, Stack } from "react-bootstrap"
import { Link } from "react-router-dom"

const ServiceList = () => {
    return (
        <Container className="margin-top-70 service margin-bottom-70">
            <Row>
                <Col md="12">
                    <h2 className="section-title m-0 text-center">Popular <span>Service</span></h2>
                    <p className="section-subtitle text-center">Services We Provide</p>
                </Col>
            </Row>
            <Row className="service-row-bottom">
                <Col md="4">
                    <Stack className="service-list">
                        <Stack className="service-list-icon">
                            <Image src="/images/ui-ux.png" />
                        </Stack>
                        <Stack className="service-list-content">
                            <label>UI / UX Design</label>
                            <p>
                                We analyze your business goals, target audience, and market trends to create a design strategy that ensures an intuitive and engaging user experience.
                            </p>
                            <Link to="" className="mx-auto read-more">
                                Read More
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                                    <path d="M0.732697 14.0132C0.421677 14.3324 0.428719 14.8441 0.749128 15.1552C1.06836 15.4662 1.58008 15.4591 1.8911 15.1387L8.12556 8.70827L7.54695 8.14609L8.12791 8.70944C8.43893 8.38786 8.43189 7.87497 8.11031 7.56395C8.10092 7.55456 8.09153 7.54635 8.08214 7.53813L1.88992 1.20742C1.5789 0.887016 1.06836 0.879974 0.747954 1.19099C0.428719 1.50201 0.421677 2.01255 0.732697 2.33296L6.42024 8.14843L0.732697 14.0132Z" fill="#FF4103"/>
                                </svg>
                            </Link>
                        </Stack>
                    </Stack>
                </Col>
                <Col md="4">
                    <Stack className="service-list">
                        <Stack className="service-list-icon">
                            <Image src="/images/web-developer.png" />
                        </Stack>
                        <Stack className="service-list-content">
                            <label>Web Developers</label>
                            <p>
                                We develop custom websites from scratch using modern frameworks like Laravel, Core PHP, and Next.js to match your specific business requirements.
                            </p>
                            <Link to="" className="mx-auto read-more">
                                Read More
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                                    <path d="M0.732697 14.0132C0.421677 14.3324 0.428719 14.8441 0.749128 15.1552C1.06836 15.4662 1.58008 15.4591 1.8911 15.1387L8.12556 8.70827L7.54695 8.14609L8.12791 8.70944C8.43893 8.38786 8.43189 7.87497 8.11031 7.56395C8.10092 7.55456 8.09153 7.54635 8.08214 7.53813L1.88992 1.20742C1.5789 0.887016 1.06836 0.879974 0.747954 1.19099C0.428719 1.50201 0.421677 2.01255 0.732697 2.33296L6.42024 8.14843L0.732697 14.0132Z" fill="#FF4103"/>
                                </svg>
                            </Link>
                        </Stack>
                    </Stack>
                </Col>
                <Col md="4">
                    <Stack className="service-list">
                        <Stack className="service-list-icon">
                            <Image src="/images/App-developer.png" />
                        </Stack>
                        <Stack className="service-list-content">
                            <label>App Developers</label>
                            <p>
                                Our team builds native Android apps using Kotlin and Java, and iOS apps using Swift and Objective-C for optimized performance.
                            </p>
                            <Link to="" className="mx-auto read-more">
                                Read More
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                                    <path d="M0.732697 14.0132C0.421677 14.3324 0.428719 14.8441 0.749128 15.1552C1.06836 15.4662 1.58008 15.4591 1.8911 15.1387L8.12556 8.70827L7.54695 8.14609L8.12791 8.70944C8.43893 8.38786 8.43189 7.87497 8.11031 7.56395C8.10092 7.55456 8.09153 7.54635 8.08214 7.53813L1.88992 1.20742C1.5789 0.887016 1.06836 0.879974 0.747954 1.19099C0.428719 1.50201 0.421677 2.01255 0.732697 2.33296L6.42024 8.14843L0.732697 14.0132Z" fill="#FF4103"/>
                                </svg>
                            </Link>
                        </Stack>
                    </Stack>
                </Col>
                <Col md="4">
                    <Stack className="service-list">
                        <Stack className="service-list-icon">
                            <Image src="/images/node-js.png" />
                        </Stack>
                        <Stack className="service-list-content">
                            <label>Node.Js Developers</label>
                            <p>
                                Node.js development offers high-performance, scalable, and real-time backend solutions for modern web and mobile applications.
                            </p>
                            <Link to="" className="mx-auto read-more">
                                Read More
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                                    <path d="M0.732697 14.0132C0.421677 14.3324 0.428719 14.8441 0.749128 15.1552C1.06836 15.4662 1.58008 15.4591 1.8911 15.1387L8.12556 8.70827L7.54695 8.14609L8.12791 8.70944C8.43893 8.38786 8.43189 7.87497 8.11031 7.56395C8.10092 7.55456 8.09153 7.54635 8.08214 7.53813L1.88992 1.20742C1.5789 0.887016 1.06836 0.879974 0.747954 1.19099C0.428719 1.50201 0.421677 2.01255 0.732697 2.33296L6.42024 8.14843L0.732697 14.0132Z" fill="#FF4103"/>
                                </svg>
                            </Link>
                        </Stack>
                    </Stack>
                </Col>
                <Col md="4">
                    <Stack className="service-list">
                        <Stack className="service-list-icon">
                            <Image src="/images/e-commerce-developer.png" />
                        </Stack>
                        <Stack className="service-list-content">
                            <label>Ecommerce Developers</label>
                            <p>
                                We build fully customized e-commerce stores with advanced features, intuitive navigation, and a seamless checkout process.
                            </p>
                            <Link to="" className="mx-auto read-more">
                                Read More
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                                    <path d="M0.732697 14.0132C0.421677 14.3324 0.428719 14.8441 0.749128 15.1552C1.06836 15.4662 1.58008 15.4591 1.8911 15.1387L8.12556 8.70827L7.54695 8.14609L8.12791 8.70944C8.43893 8.38786 8.43189 7.87497 8.11031 7.56395C8.10092 7.55456 8.09153 7.54635 8.08214 7.53813L1.88992 1.20742C1.5789 0.887016 1.06836 0.879974 0.747954 1.19099C0.428719 1.50201 0.421677 2.01255 0.732697 2.33296L6.42024 8.14843L0.732697 14.0132Z" fill="#FF4103"/>
                                </svg>
                            </Link>
                        </Stack>
                    </Stack>
                </Col>
                <Col md="4">
                    <Stack className="service-list">
                        <Stack className="service-list-icon">
                            <Image src="/images/seo-developer.png" />
                        </Stack>
                        <Stack className="service-list-content">
                            <label>SEO Developers</label>
                            <p>
                                An SEO developer optimizes websites for search engines by improving site structure, speed, and content to enhance visibility and rankings.
                            </p>
                            <Link to="" className="mx-auto read-more">
                                Read More
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                                    <path d="M0.732697 14.0132C0.421677 14.3324 0.428719 14.8441 0.749128 15.1552C1.06836 15.4662 1.58008 15.4591 1.8911 15.1387L8.12556 8.70827L7.54695 8.14609L8.12791 8.70944C8.43893 8.38786 8.43189 7.87497 8.11031 7.56395C8.10092 7.55456 8.09153 7.54635 8.08214 7.53813L1.88992 1.20742C1.5789 0.887016 1.06836 0.879974 0.747954 1.19099C0.428719 1.50201 0.421677 2.01255 0.732697 2.33296L6.42024 8.14843L0.732697 14.0132Z" fill="#FF4103"/>
                                </svg>
                            </Link>
                        </Stack>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default ServiceList